import ROUTE_NAMES from "@/app/exercise/router/router-const";
export default [
  {
    path: "payments",
    name: ROUTE_NAMES.PAYMENTS,
    redirect: { name: ROUTE_NAMES.PAYMENTS_ORDERS },
    component: () =>
      import("@/app/exercise/modules/payments/PaymentsPage.vue"),
    children: [
      {
        path: "plans",
        name: ROUTE_NAMES.PAYMENTS_PLANS,
        component: () =>
          import("@/app/exercise/modules/payments/components/PlansTab.vue")
      },
      {
        path: "orders",
        name: ROUTE_NAMES.PAYMENTS_ORDERS,
        component: () =>
          import("@/app/exercise/modules/payments/components/OrdersTab.vue")
      },
    ],
  }
];
